import {css} from "@emotion/css";
import {convertCurrencyFormatPositiveNegative, convertToDateFormat} from "../../util/numberConvertor";
import RaikoMaterialOutlinedInput from "../raikoInputs/RaikoMaterialOutlinedInput";
import React from "react";
import PropTypes from "prop-types";

const RaikoSearchInputOutlined = (
    {
        labelText,
        className,
        placeHolder,
        value,
        setValue,
        disabled
    }) => {

    return (
        <RaikoMaterialOutlinedInput
            placeHolder={placeHolder}
            labelText={labelText}
            className={`
            ${
                css`
                  direction: ltr;
                  text-align: end;
                `
            } ${
                className
            }`}
            disabled={disabled}
            value={convertToDateFormat(value)}
            onChange={({target}) => {
                setValue(target.value)
            }}/>
    )

}

RaikoSearchInputOutlined.propTypes = {
    placeHolder: PropTypes.string,
    disabled: PropTypes.bool,
    labelText: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired
}

export default RaikoSearchInputOutlined